import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import React, { useContext } from 'react'
import Slider, { Settings } from 'react-slick'

import colorContext from '../../../../Context/colorContext'
// import { ListBanners } from '../..';

// interface Props {
//   listBanners: ListBanners[];
// }

const Banners = (): JSX.Element => {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '80px 5px',
      overflowX: 'hidden',
      backgroundColor: '#EDEDED',
    },
    bannerMain: {
      width: '100%',
      height: 'auto',
      borderRadius: 4,
      maxHeight: 382,
    },
    textTitleInitial: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 'bold',
      color: colors.textBody,
      left: 8,
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 24,
        backgroundColor: colors.textBody,
        position: 'absolute',
        bottom: 6,
        marginLeft: -14,
        left: 5,
      },
    },
    textSubTitle: {
      position: 'relative',
      fontFamily: 'Roboto',
      paddingBottom: 10,
      color: colors.textBody,
      letterSpacing: '0.1px',
      lineHeight: '24px',
      fontWeight: 400,
      fontSize: 18,
      opacity: 0.5,
    },
    boxImage: {
      height: '100%',
      // maxHeight: 400,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    legend: {
      position: 'absolute',
      zIndex: 9999,
      top: '70%',
      left: 0,
      right: 0,
      backgroundColor: 'rgba(11, 11, 11, 0.36)',
      padding: 10,
    },
    textLegend: {
      textTransform: 'capitalize',
      textDecoration: 'none',
      color: colors.textAccentColor,
      fontFamily: 'Roboto',
      fontSize: 16,
      fontWeight: 600,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    slider: {
      '& .slick-list': {
        margin: 0,
      },
      '& .slick-dots': {
        bottom: '-35px',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .slick-slide': {
        padding: 0,
      },
      '& .slick-track': {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#EDEDED',
      },
      '& .slick-dots ul': {
        padding: 0,
      },
      '& .slick-dots li': {
        margin: 0,
      },
      '& .slick-dots li button:before': {
        opacity: 0.24,
        color: colors.accentColor,
        fontSize: 12,
      },
      '& .slick-dots li.slick-active button:before': {
        opacity: 1,
        color: colors.accentColor,
      },
    },
  }))
  const classes = useStyles()

  const settings: Settings = {
    speed: 500,
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <Box className={classes.main}>
      <Box
        display="flex"
        maxWidth="1320px"
        width="100%"
        justifyContent="center"
        alignItems="center"
      >
        <Box className={classes.bannerMain}>
          <Slider {...settings} className={classes.slider}>
            {/* {listBanners.map((banner) => (
              <Box
                className={classes.boxImage}
                key={`${banner.titulo}-key`}
                onClick={(): void => (window as any).open(banner.url)}
              >
                <img
                  src={banner.url_imagem}
                  alt={banner.titulo}
                  style={{
                    width: '100%',
                  }}
                />
              </Box>
            ))} */}
          </Slider>
        </Box>
      </Box>
    </Box>
  )
}

export default Banners
